import { CpRefundOnlineProcessRequestInterface } from '../../../interfaces/request/refund-online-process/cp-refund-online-process-request-interface';

export class CpRefundOnlineProcessRequestModel implements CpRefundOnlineProcessRequestInterface {
  Cards: string = '';
  EndDate: string = '';
  Page: number = 1;
  PageSize: number = 5;
  StartDate: string = '';

  constructor(init?: Partial<CpRefundOnlineProcessRequestModel>) {
    Object.assign(this, init);
  }
}
